export default __webpack_public_path__ + "static/media/RPG.419c4795.svg";